$(document).ready(function(){
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  var windowWidth = $(window).width();
  var titleWidth = $('.title').width();
  $('.title').css('transform','translate('+(((windowWidth-titleWidth)/2))+'px,'+(((windowHeight-titleHeight)/2))+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','600ms');
    $('.title').addClass('active2');
  },700);
  setTimeout(function(){
    $('header').addClass('active');
    $('.title').css('transform','translate(0,0)');
    $('.overlay').fadeOut(800);
  },1200);
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.5;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }
    });
  });


  var mainSwiper = new Swiper('#slider', {
    // パラメーター
    loop: true,
    slidesPerView: 4,
    speed:4000,
    allowTouchMove: false,
    autoplay: {delay: 0},
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween:20
      }
    }
  });
  $(window).resize(function(){
      mainSwiper.autoplay.paused = false;
      mainSwiper.autoplay.start();
  });

  // modal
    $('.swiper-slide').click(function(){
      var modalImg = $(this).html();
      $('body').append('<div class="modal_bg flex flex_middle flex_center"><div class="modal_img">'+modalImg+'</div></div>');
      $('body').css('overflow','hidden');

      $('.modal_bg').click(function(){
        $(this).remove();
        $('body').css('overflow','auto');
      });
    });


    $(window).on('load resize',function(){
      var bottomHeight = $('.outro_wrapper').outerHeight();
      var footerHeight = $('footer').outerHeight();
      var windowHeight = $( window ).height();
      var bgPos = windowHeight - (bottomHeight + footerHeight);
      $('.outro_wrapper').css('background-position','top '+bgPos+'px center');
    });


    $('.sp_menu_btn').click(function(){
      $('header').toggleClass('open');
    });
    $('.header_menu_bottom ul li a').click(function(){
      $('header').removeClass('open');
    });

});
